import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const InvoiceManagementSchema =

  Yup.object().shape({
    invoiceId: Yup.string(),
    toCompanyId: Yup.string().required(Validation.required.message.replaceAll("^", "Company Name"))
      .matches(Validation.plaintext.regex, Validation.plaintext.message),

    subject: Yup.string().required(Validation.required.message.replaceAll("^", "Subject"))
      .matches(Validation.plaintext.regex, Validation.plaintext.message),
    status: Yup.string().required(Validation.required.message.replaceAll("^", "status"))
      .matches(Validation.plaintext.regex, Validation.plaintext.message),
    amount: Yup.string().required(Validation.required.message.replaceAll("^", "Amount"))
       .matches(Validation.amount.regex, Validation.amount.message),
    currency: Yup.string().required(Validation.required.message.replaceAll("^", "Currency"))
      .matches(Validation.plaintext.regex, Validation.plaintext.message),

    // bankId: Yup.string().required(Validation.required.message.replaceAll("^", "Bank")),

    paidDate: Yup.string().when("status", {
      is: (value) => value === msgTypes.INVOICE_STATUS.PAID,
      then: () => Yup.string().required(Validation.required.message.replaceAll("^", "Paid Date"))
    }),

    dueDate: Yup.string().when("status", {
      is: (value) => value === msgTypes.INVOICE_STATUS.OUTSTANDING,
      then: () => Yup.string().required(Validation.required.message.replaceAll("^", "Due Date"))
    }),
    // uploadedInvoice: Yup.string(),//.required(Validation.required.message.replaceAll("^", "Upload Invoice")),
    uploadedInvoiceFile: Yup.mixed().nullable()
      .test(
        "FILE_FORMAT",
        msgTypes.IMAGE_UNSUPPORTED_FORMATS,
        (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF
        ].includes(value?.type))
      )
      .test(
        "FILE_SIZE",
        msgTypes.FILE_SIZE_MESSAGE_3MB,
        (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
      )


  })






